module.exports = __webpack_public_path__ + "img/SSD-fountain.1638bc50.jpg";